export default function SalaryInformation({ searchObject, onChange, t }) {
  return (
    <div>
      <legend className="fontsize-legend">{t("Salary Information")}</legend>
      <input
        name="salaryInformation"
        onChange={onChange}
        value={searchObject.salaryInformation || ""}
        className="form-control fontsize-legend"
      />
    </div>
  );
}
